import React from 'react';
import {
  Alert,
  AlertProps,
  AlertIcon,
  HStack,
  AlertDescription,
  CloseButton,
} from '@chakra-ui/react';

export interface SnackbarAlertProps {
  message: string;
  status: AlertProps['status'];
  onClose: () => void;
}

const SnackbarAlert: React.FC<SnackbarAlertProps> = ({
  message,
  status,
  onClose,
}) => (
  <Alert
    status={status}
    bg="dark.500"
    color="bright.500"
    rounded="none"
    px="3"
    py="2"
  >
    <AlertIcon opacity={0.75} />
    <HStack w="full" justify="space-between">
      <AlertDescription>{message}</AlertDescription>
      <CloseButton ml="2" onClick={onClose} />
    </HStack>
  </Alert>
);

export default SnackbarAlert;
